var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4286 1.71094H0.571429C0.255357 1.71094 0 1.96629 0 2.28237V13.7109C0 14.027 0.255357 14.2824 0.571429 14.2824H15.4286C15.7446 14.2824 16 14.027 16 13.7109V2.28237C16 1.96629 15.7446 1.71094 15.4286 1.71094ZM14.7143 3.68951V12.9967H1.28571V3.68951L0.792857 3.30558L1.49464 2.40379L2.25893 2.99844H13.7429L14.5071 2.40379L15.2089 3.30558L14.7143 3.68951ZM13.7429 2.99665L8 7.46094L2.25714 2.99665L1.49286 2.40201L0.791072 3.30379L1.28393 3.68772L7.38393 8.43058C7.55936 8.56687 7.77518 8.64085 7.99732 8.64085C8.21947 8.64085 8.43529 8.56687 8.61071 8.43058L14.7143 3.68951L15.2071 3.30558L14.5054 2.40379L13.7429 2.99665Z",
    fill: "#344054"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.ef8a8c6633596bcd8f21743724e287a0.svg";
export { ForwardRef as ReactComponent };